import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {LienTache} from '../../../../models/taches/gestion-taches.model';
import {Subscription} from 'rxjs';
import {SessionDetailleeModel} from '../../../../models/sessions/session-detaillee-model';
import {SessionsService} from '../../../../services/sessions/sessions-service';

@Component({
  selector: 'app-lien-session-details-tooltip',
  templateUrl: './lien-session-details-tooltip.component.html',
  styleUrls: ['./lien-session-details-tooltip.component.scss']
})
export class LienSessionDetailsTooltipComponent implements OnInit , OnDestroy{
  @Input() set lien(value: LienTache) {
    if (value != null) {
      this.idSession = value.idOriginal;
      this.loadSession(this.idSession);
    }
  }
  private idSession: number = null;
  public session: SessionDetailleeModel;
  public sub: Subscription[] = [];

  constructor(private sessionsService: SessionsService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.sub.map(ob => ob.unsubscribe());
  }

  private loadSession(id: number) {
    this.sub.push(
      this.sessionsService.chargerSession(id).subscribe(session => {
        this.session = session
      })
    );
  }

}
